//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Calendar
//   Details:    Calendar component
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103563 18/09/19 JHT M01  added calendarstyle
//  84474 26/09/19 JC  M02  Need to URI encode the site
// 105066 06/01/20 JC  M03  Added font awesome
// 108238 10/06/20 JC  M04  Re-wrote datetime components
// WI4743 24/02/25 JC  M05JC Handled isWorking day
//-------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { history } from '../history';
import { connect } from 'react-redux';
import { weeksActions } from '../store/Weeks';
import { utils } from '../utils/utils';
//M04 import Moment from 'react-moment';
import DateTime from './DateTime'; //M04
import { dateTimeTypes } from '../constants/DateTimeTypes'; //M04
import moment from 'moment';
//M03 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M03
import CalendarDay from './CalendarDay';
import './css/Calendar.css';
import { requestActions } from '../store/Request';

class Calendar extends Component {
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handlePrev = this.handlePrev.bind(this);
		this.handleNext = this.handleNext.bind(this);
	}

	handleClick = (requestId, date) => {
		const id = +requestId;
		const { siteId, site, year, month } = this.props;
				
		if (id === 0) {
			// Only create new requests for dates for today and after
			if (moment().isSameOrBefore(date, "day")) {
				this.props.setFromCalendar({ siteId, site, year, month });
				history.push(`/myrequests/detail/${requestId}/${utils.truncateDate(date)}`);
			}
		}
		else if (id > 0) {
			this.props.setFromCalendar({ siteId, site, year, month });
			//M05JC add the date so we get working times
			history.push(`/myrequests/detail/${requestId}/${utils.truncateDate(date)}`);
		}		
	}

	handlePrev = event => {
		event.preventDefault();
		let { siteId, site, year, month } = this.props;

		month--;
		if (month < 1) {
			month += 12;
			year--;
		}

        history.push(`/myplan/site/${siteId}/${encodeURIComponent(site)}/${year}/${month}`);//M02
	}

	handleNext = event => {
		event.preventDefault();
		let { siteId, site, year, month } = this.props;

		month++;
		if (month > 12) {
			month -= 12;
			year++;
		}

        history.push(`/myplan/site/${siteId}/${encodeURIComponent(site)}/${year}/${month}`); //M02
	}

    //M01
    getClassForState(forState) {
        // delegate to weeks
        return this.props.getClassForStateSample(forState);
    }


	render() {
		const { isLoading, weeks, year, month } = this.props;
		const date = "" + (year < 10 ? "0" : "") + year + "-" + (month < 10 ? "0" : "") + month + "-01";

		return (
			<div>
				<div className={`text-center button-tray ${isLoading ? "list-loading" : ""}`}>
					<div className="button-group float-left">
                        <button className="btn btn-default" onClick={this.handlePrev}><FontAwesomeIcon icon="chevron-left" /> Previous</button> {/*M03*/}
					</div>
                    <span className="float-centre"><DateTime value={date} dateTimeType={dateTimeTypes.date} disabled={true} disabledFormat="MMM YYYY" /></span> {/*M04*/}
					<div className="button-group float-right">
                        <button className="btn btn-default" onClick={this.handleNext}>Next <FontAwesomeIcon icon="chevron-right" /></button> {/*M03*/}
					</div>
					<div className="clearfix" />
				</div>

				<table className="calendar-table">
					<thead>
						<tr>
							<th><h5>Mon</h5></th>
							<th><h5>Tue</h5></th>
							<th><h5>Wed</h5></th>
							<th><h5>Thu</h5></th>
							<th><h5>Fri</h5></th>
							<th><h5>Sat</h5></th>
							<th><h5>Sun</h5></th>
						</tr>
					</thead>
					<tbody>
						{weeks.map(week => {
							return week.days && week.days.length
								? <tr key={week.weekStartDate}>
									{week.days.map(day => {
										return (
											<td key={day.date} className={day.stateClass} title={day.stateText}>
												<CalendarDay
													onSelected={this.handleClick}
													requestId={day.requestId}
													date={day.date}
													state={day.state}
													isInMonth={day.isInMonth}
													isToday={day.isToday}
													isWorking={day.isWorking /*M05JC*/}
												/>
											</td>
										);
									})}
								</tr>
								: [];
						})}
					</tbody>
				</table>


				<br />
				<br />
				<h5>Key</h5>
				<table className="calendar-table samples">
					<thead>
						<tr>
							<th><h5>Holiday</h5></th>
							<th><h5>Absence</h5></th>
						</tr>
					</thead>
					<tbody>
						<tr>
                            <td className={this.getClassForState(2)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="clock" /> Pending
							</td>
                            <td className={this.getClassForState(6)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="clock" /> Pending
							</td>
						</tr>
						<tr>
                            <td className={this.getClassForState(3)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="check" /> Approved/used
							</td>
                            <td className={this.getClassForState(7)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="check" /> Approved/used
							</td>
						</tr>
						<tr>
                            <td className={this.getClassForState(4)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="times" /> Rejected
							</td>
                            <td className={this.getClassForState(8)}> {/*M01 M03*/} 
                                <FontAwesomeIcon icon="times" /> Rejected
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}

Calendar.propTypes = {
	weeks: PropTypes.arrayOf(
		PropTypes.shape({
			days: PropTypes.arrayOf(
				PropTypes.shape({
					stateClass: PropTypes.string.isRequired,
					stateText: PropTypes.string.isRequired,
					requestId: PropTypes.number,
					date: PropTypes.string.isRequired,
					state: PropTypes.number.isRequired,
					isInMonth: PropTypes.bool.isRequired,
					isToday: PropTypes.bool.isRequired,
					isWorking: PropTypes.bool.isRequired //M05JC
				})
			)
		})
	)
};

export default connect(
	null,
	dispatch => bindActionCreators({ ...weeksActions, ...requestActions}, dispatch)
)(Calendar);
